"use client";

import { useState } from "react";
import { Button } from "@/components/ui/button";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const filters = ["ALL", "SUPPORT", "BOOKING", "MARKETING", "WORKFLOW"];
const projects = [{
  number: "01",
  name: "Support Nexus",
  location: "SYDNEY, AU",
  category: "SUPPORT",
  span: "md:col-span-2 md:row-span-2",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/automation_support_nexus.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/automation_support_nexus.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/automation_support_nexus.webp-wvc-sizes",
  alt: "AI customer support dashboard interface"
}, {
  number: "02",
  name: "Flow Sync",
  location: "MELBOURNE, AU",
  category: "WORKFLOW",
  span: "md:col-span-2 md:row-span-1",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/automation_flow_sync.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/automation_flow_sync.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/automation_flow_sync.png-wvc-sizes",
  alt: "Workflow automation visualization"
}, {
  number: "03",
  name: "Booking Engine",
  location: "BRISBANE, AU",
  category: "BOOKING",
  span: "md:col-span-1 md:row-span-2",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/automation_booking_engine.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/automation_booking_engine.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/automation_booking_engine.png-wvc-sizes",
  alt: "Automated appointment scheduling system"
}, {
  number: "04",
  name: "Lead Pulse",
  location: "PERTH, AU",
  category: "MARKETING",
  span: "md:col-span-1 md:row-span-1",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/automation_lead_pulse.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/automation_lead_pulse.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/automation_lead_pulse.png-wvc-sizes",
  alt: "Email marketing automation analytics"
}, {
  number: "05",
  name: "Invoice Logic",
  location: "ADELAIDE, AU",
  category: "WORKFLOW",
  span: "md:col-span-1 md:row-span-1",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/automation_invoice_logic.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/automation_invoice_logic.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/automation_invoice_logic.png-wvc-sizes",
  alt: "Automated invoicing and billing system"
}, {
  number: "06",
  name: "Chat Intelligence",
  location: "HOBART, AU",
  category: "SUPPORT",
  span: "md:col-span-2 md:row-span-1",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/automation_chat_intel.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/automation_chat_intel.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/automation_chat_intel.webp-wvc-sizes",
  alt: "AI chatbot interface design"
}, {
  number: "07",
  name: "Schedule Pro",
  location: "DARWIN, AU",
  category: "BOOKING",
  span: "md:col-span-1 md:row-span-1",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/automation_schedule_pro.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/automation_schedule_pro.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/automation_schedule_pro.png-wvc-sizes",
  alt: "Advanced booking automation"
}, {
  number: "08",
  name: "Growth Automator",
  location: "CANBERRA, AU",
  category: "MARKETING",
  span: "md:col-span-2 md:row-span-2",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/automation_growth_engine.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/automation_growth_engine.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/automation_growth_engine.webp-wvc-sizes",
  alt: "Marketing automation growth dashboard"
}, {
  number: "09",
  name: "Data Stream",
  location: "GOLD COAST, AU",
  category: "WORKFLOW",
  span: "md:col-span-1 md:row-span-1",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/automation_data_stream.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/automation_data_stream.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/automation_data_stream.png-wvc-sizes",
  alt: "Data workflow integration"
}, {
  number: "10",
  name: "Support AI",
  location: "CAIRNS, AU",
  category: "SUPPORT",
  span: "md:col-span-1 md:row-span-1",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/automation_support_ai.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/automation_support_ai.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/automation_support_ai.webp-wvc-sizes",
  alt: "AI support automation"
}, {
  number: "11",
  name: "Booking Flow",
  location: "GEELONG, AU",
  category: "BOOKING",
  span: "md:col-span-2 md:row-span-1",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/automation_booking_flow.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/automation_booking_flow.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/automation_booking_flow.png-wvc-sizes",
  alt: "Seamless booking automation"
}, {
  number: "12",
  name: "Marketing Sync",
  location: "NEWCASTLE, AU",
  category: "MARKETING",
  span: "md:col-span-2 md:row-span-1",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/automation_marketing_sync.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/automation_marketing_sync.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/automation_marketing_sync.png-wvc-sizes",
  alt: "Marketing sync automation"
}];
export default function Results() {
  const [activeFilter, setActiveFilter] = useState("ALL");
  const intro = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const grid = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.05
  });
  const visibleProjects = activeFilter === "ALL" ? projects : projects.filter(p => p.category === activeFilter);
  return <section data-section-id="3521" id="proven-results" className="bg-background text-foreground relative overflow-hidden py-20 md:py-32">
      <div ref={intro.ref} className={`container mx-auto px-6 md:px-10 transition-all duration-1000 ease-out ${intro.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start min-h-[60vh] lg:min-h-[80vh]">
          <div className="lg:col-span-7 flex flex-col justify-between h-full">
            <div className="flex items-start gap-6">
              <span className="font-mono text-[11px] tracking-[0.2em] uppercase text-foreground/70 writing-mode-vertical" style={{
              writingMode: "vertical-rl",
              transform: "rotate(180deg)"
            }}>
                AUTOMATION / 2024 — 2025
              </span>
              <h1 className="font-default font-extrabold uppercase leading-[0.85] tracking-[-0.04em] text-foreground text-[18vw] md:text-[14vw] lg:text-[9rem] xl:text-[10rem]">
                PROVEN
                <br />
                <span className="text-foreground/70">RESULTS</span>
                <span className="text-foreground/70">.</span>
              </h1>
            </div>
          </div>

          <div className="lg:col-span-5 flex flex-col justify-end gap-10 h-full">
            <p className="font-default text-lg md:text-xl leading-relaxed text-muted-foreground max-w-[480px]">
              A record of operational excellence where AI meets business logic. 
              Every deployment below represents a shift from manual friction to 
              autonomous efficiency, proving that smart technology is the ultimate 
              competitive advantage.
            </p>

            <div className="hidden md:flex flex-wrap gap-3">
              {filters.map((filter, i) => <Button key={filter} data-index={i} onClick={() => setActiveFilter(filter)} variant="ghost" className={`h-10 px-5 font-default font-bold text-xs uppercase tracking-[0.15em] border transition-all duration-300 ${activeFilter === filter ? "bg-foreground/10 text-foreground border-foreground/20 hover:bg-foreground/20 hover:text-foreground" : "bg-foreground/5 backdrop-blur-md border-foreground/20 text-foreground hover:bg-foreground/10 hover:text-foreground"}`}>
                  {filter}
                </Button>)}
            </div>

            <div className="md:hidden -mx-6">
              <ScrollArea className="w-full whitespace-nowrap">
                <div className="flex gap-3 px-6 pb-3">
                  {filters.map((filter, i) => <Button key={filter} data-index={i} onClick={() => setActiveFilter(filter)} variant="ghost" className={`h-10 px-5 font-default font-bold text-xs uppercase tracking-[0.15em] border transition-all duration-300 shrink-0 ${activeFilter === filter ? "bg-foreground/10 text-foreground border-foreground/20 hover:bg-foreground/20 hover:text-foreground" : "bg-foreground/5 backdrop-blur-md border-foreground/20 text-foreground hover:bg-foreground/10 hover:text-foreground"}`}>
                      {filter}
                    </Button>)}
                </div>
                <ScrollBar orientation="horizontal" />
              </ScrollArea>
            </div>
          </div>
        </div>
      </div>

      <div ref={grid.ref} className={`container mx-auto px-6 md:px-10 mt-20 md:mt-32 transition-all duration-1000 ease-out ${grid.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="grid grid-cols-1 md:grid-cols-4 auto-rows-[280px] md:auto-rows-[320px] gap-6">
          {visibleProjects.map((project, i) => <div key={project.number} data-index={i} className={`group relative overflow-hidden cursor-pointer shadow-lg ${project.span}`}>
              <img src={project.image} data-wvc-srcset={project.srcset} data-wvc-sizes={project.sizes} alt={project.alt} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover grayscale-[90%] group-hover:grayscale-0 transition-all duration-[600ms] ease-out group-hover:scale-[1.04]" />

              <div className="absolute inset-0 bg-background/20 group-hover:bg-background/0 transition-colors duration-500" />

              <div className="absolute top-4 right-4 w-5 h-5 pointer-events-none z-10">
                <span className="absolute top-0 right-0 w-5 h-[1.5px] bg-foreground/70" />
                <span className="absolute top-0 right-0 w-[1.5px] h-5 bg-foreground/70" />
              </div>

              <div className="absolute left-0 right-0 bottom-0 bg-foreground/70 text-background translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out px-5 py-4">
                <div className="flex items-baseline justify-between gap-4">
                  <div className="flex items-baseline gap-3 min-w-0">
                    <span className="font-mono font-bold text-xs shrink-0">
                      ID{project.number}
                    </span>
                    <h3 className="font-default font-bold text-lg md:text-xl truncate">
                      {project.name}
                    </h3>
                  </div>
                  <span className="font-default text-[11px] uppercase tracking-[0.15em] shrink-0 hidden sm:block">
                    {project.location}
                  </span>
                </div>
                <span className="font-default text-[11px] uppercase tracking-[0.15em] sm:hidden block mt-1">
                  {project.location}
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}